import { render, staticRenderFns } from "./ActiveComplaints.vue?vue&type=template&id=4296d35a&scoped=true"
import script from "./ActiveComplaints.vue?vue&type=script&lang=js"
export * from "./ActiveComplaints.vue?vue&type=script&lang=js"
import style0 from "./ActiveComplaints.vue?vue&type=style&index=0&id=4296d35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296d35a",
  null
  
)

export default component.exports